import React, {useEffect, useRef,useState } from "react"; 
import { Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from 'react-toastify';
import { getSystemUserByID } from "../../../../Services/User/SystemUserService";
const ViewSystemUser = ({ isShow,close, editUserId }) => {  
  const handleShow = () => setShow(true);
  const handleClose = () => {setShow(false);close()};
  const [show, setShow] = useState(false);
  const [name, setName] = useState(false);
  const [email, setEmail] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [role, setRole] = useState(false);
  useEffect(() => { 
    setShow(isShow)
     const fetchUserDetails = async (editUserId) => {
          try {
            const response = await getSystemUserByID(editUserId);
            if (response?.status) {
              setName(response.data.name);
              setEmail(response.data.email)
              setMobile(response.data.mobile_number);
              setRole(response.data.roles.role)
            } else {
              toast.error("Failed to fetch user details");
            }
          } catch (error) {
            console.error("Error fetching user details:", error);
            toast.error("Error fetching user details");
          }
        };
        fetchUserDetails(editUserId);
  }, []); 
  return ( 
    <Modal show={show} onHide={handleClose} >
        <Modal.Header closeButton>
        <h5 className="modal-title">System User</h5>
        </Modal.Header>
        <Modal.Body>  
        <form className="row g-3">
              <div className="col-12 px-3">
                <label for="viewSystemUserName" className="form-label"> Name : {name} </label>
                 <span id="viewSystemUserName"></span>
              </div>
              <div className="col-12 px-3">
                <label for="viewSystemUserEmail" className="form-label" >Email : {email}</label>
                <span id="viewSystemUserEmail"></span>
              </div> 
              <div className="col-12 px-3">
                <label for="viewCountryCode" className="form-label">Country Code : 91 </label>
                <span id="viewCountryCode"></span> 
              </div>
              <div className="col-12 px-3">
                <label for="viewMobileNo" className="form-label">Mobile Number : {mobile} </label>
                <span id="viewMobileNo"></span>
              </div>
              <div className="col-12 px-3">
                <label for="viewRole" className="form-label">Role : {role}</label>
                <span id="viewRole"></span> 
              </div>
            </form> 
        </Modal.Body>
        <Modal.Footer>             
        </Modal.Footer>
      </Modal>
       
  );
};

export default ViewSystemUser;
 